import styled, {keyframes} from 'styled-components'
import {Link} from 'react-router-dom'
import Settings from '../../Settings'
import {FullSizeInContainer} from './../common/StyledComponents'
import bgImage from './../../theme/img/home-bg.png'
import clicker from './../../theme/img/clicker.png'

export const CategoryButtons = styled(FullSizeInContainer)`
    background: transparent url('${bgImage}') no-repeat center;
    background-size: cover;
`

export const CategoryButton = styled(Link)`
  position: absolute;
  top: ${props => props.position.top}%;
  left: ${props => props.position.left}%;
  width: ${props => props.size.width}%;
  height: 0;
  padding-bottom: ${props => props.size.height}%;
  display: block;
  border-radius: 22%;
  transition: background-color 250ms;

  > div {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  > span {
    position: absolute;
    width: 100%;
    top: 100%;
    margin-top: 2vw;
    color: #fff;
    left: 0;
    text-align: center;
    font-weight: bold;
    font-size: 1.5vw;
  }

  :hover {
    background-color: ${Settings.themeColor};
  }
`

const helpAnimation = ({to, size}) => keyframes`
  0% {
    opacity: 0;
    transform: translate(0vw, 30vh) scale(1);
  }

  30%, 45% {
    transform: translate(${to.left + size.width / 2}vw, ${to.top + size.height / 2}vh) scale(1);
    opacity: 1;
  }

  50% {
    transform: translate(${to.left + size.width / 2}vw, ${to.top + size.height / 2}vh) scale(.85);
    opacity: 1;
  }

  55%, 70% {
    transform: translate(${to.left + size.width / 2}vw, ${to.top + size.height / 2}vh) scale(1);
    opacity: 1;
  }

  100% {
    transform: translate(100vw, 70vh) scale(1);
    opacity: 0;
  }
`

export const HelpAnimation = styled.div`
  animation: ${props => helpAnimation(props)} 4s linear 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 4vw;
  height: 4vw;
  background: url(${clicker}) no-repeat center center;
  background-size: contain;
  opacity: 0;
  transform: translate(0vw, 0vh) scale(1);
`

export const HelpAnimationContainer = styled(FullSizeInContainer)`
  overflow: hidden;
  pointer-events: none;
`
